import { replaceHtmlEntities } from "@/src-refactor/modules/shared/helpers/parse-html-values";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const position: { [key: string]: I_GENERIC_ITEMS } = {
  ["Esquina"]: {
    label: "Esquina",
    value: 175,
    id: 175,
    name: "Esquina"
  },
  ["Medial"]: {
    label: "Medial",
    value: 174,
    id: 174,
    name: "Medial"
  }
};

interface IFeaturesToClient {
  use: I_GENERIC_ITEMS[];
  position: I_GENERIC_ITEMS[];
  features: I_GENERIC_ITEMS[];
  characteristics_frames: I_GENERIC_ITEMS[];
  characteristics_doors: I_GENERIC_ITEMS[];
  characteristics_closets: I_GENERIC_ITEMS[];
  characteristics_cabinets: I_GENERIC_ITEMS[];
  characteristics_floors: I_GENERIC_ITEMS[];
  characteristics_windows: I_GENERIC_ITEMS[];
  characteristics_type_house: I_GENERIC_ITEMS[];
  characteristics_roof: I_GENERIC_ITEMS[];
  characteristics_roof_form: I_GENERIC_ITEMS[];
}
const prepareFeaturesToClient = (res: IPropertyDetailsResponse) => {
  const featuresObj: IFeaturesToClient = {
    use: [],
    position: [],
    features: [],
    characteristics_frames: [],
    characteristics_doors: [],
    characteristics_closets: [],
    characteristics_cabinets: [],
    characteristics_floors: [],
    characteristics_windows: [],
    characteristics_type_house: [],
    characteristics_roof: [],
    characteristics_roof_form: []
  };
  if (res?.improvements_list) {
    res?.improvements_list.forEach(item => {
      if (item.name === "Uso") {
        featuresObj.use.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Ubicaci&oacute;n") {
        featuresObj.position.push(position[item.value]);
      }
      if (item.name === "Marcos") {
        featuresObj.characteristics_frames.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Gabinetes") {
        featuresObj.characteristics_cabinets.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Puertas") {
        featuresObj.characteristics_doors.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Ventanas") {
        featuresObj.characteristics_windows.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Pisos") {
        featuresObj.characteristics_floors.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Techo") {
        featuresObj.characteristics_roof.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name === "Mejoras") {
        featuresObj.features.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name == "Closets") {
        featuresObj.characteristics_closets.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
      if (item.name == "Forma techo") {
        featuresObj.characteristics_roof_form.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }

      if (item.id == 5) {
        featuresObj.characteristics_type_house.push({
          label: replaceHtmlEntities(item.value),
          value: item.feature_values_id,
          name: replaceHtmlEntities(item.value),
          id: item.feature_values_id
        });
      }
    });
  }

  return featuresObj;
};
export default prepareFeaturesToClient;
